module.exports = __webpack_public_path__ + "static/pie_painter_4-35a28bd37e1a56f14f5f29bf0e519604.png";